import { IEntity } from '../../../libraries/entity';
import { createAction } from '../actions';
import { AppDispatch } from '../store';
import { ActionTypes } from './actionTypes';

export const saveEntitiesInfo = (entitiesInfo: IEntity[]) => (dispatch: AppDispatch) => {
  dispatch(createAction(ActionTypes.SAVE_ENTITIES, entitiesInfo));
};
